// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1KtpK","subheader":"ReorderModal_subheader__2MfoW","listWrap":"ReorderModal_listWrap__20D4C"};